function createMockGenerator(generatorFn) {
  return function generate(length) {
    return Array.from({ length }, (_, index) => generatorFn(index))
  }
}

exports.__esModule = true
exports.createMockGenerator = createMockGenerator
